import Vue from "vue";
let currentRequest = 0;

const PermaLinkService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("permalink", id, {});
      return data.data[0];
    } catch (error) {
      console.log("error fetchOne: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START PERMALINK `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll(
        "permalinks",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] PERMALINK DISCARDED`);
        return null;
      }
      console.log(`[${request}] END PERMALINK `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("error fetchAll: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("permalink", payload);
      } else {
        return await Vue.$jsonApi.update("permalink", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("permalink", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  },
};

export { PermaLinkService };
